module.exports = __webpack_public_path__ + "img/cat-empty-ahorros-white.6649c3dc.svg";